'use strict';

angular.module('imagetrend.components')
    .directive('hlpFormQuestion', ['$q', '$rootScope', 'Vehicles', 'Users', 'Trainings', function ($q, $rootScope, Vehicles, Users, Trainings) {
        return {
            restrict: 'AE',
            scope: {
                question: '=?',
                parameters: '=?',
                checkboxOrRadio: '=?',
                resultSet: '=?',
                deficiencies: '=?',
                pdf: '=?',
                group: '=?',
                datapointAnswers: '=?',
                completed: '=?',
                saving: '=?',
                deficiencyScore: "=?",
                inspectionChecklist: "=?",
                defaultGroup: "=?",
                groups: "=?" // for service user affiliations (positions)
            },
            replace: true,
            transclude: true,
            templateUrl: 'templates/form-builder-form/form-question/form-question.html',
            link: function (scope, elem, attrs, ctrl) {
                scope.locationParameters = {
                    locationIntegrationId: $rootScope.locationIntegration.id
                };
                scope.locationIntegrationEnabled = $rootScope.locationIntegration.enable;
                scope.selectedLocation = null;

                scope.dynamicDelete = function (question) {
                    question.answer.value = null;
                    question.answer.show_value = null;
                    scope.group.added = true;
                    scope.answerChanged(question);
                }
                scope.previousAction = '';

                scope.dynamicDeleteShow = function (question) {
                    return question.answer.value != null && (question.allow_dynamic_addition || question.allow_dynamic_edit) && (scope.group.added || question.answer.value == nullGuid());
                }

                scope.dynamicAdd = function (question) {
                    question.answer.value = nullGuid();
                    question.answer.show_value = '[New]';
                }

                scope.dynamicAddShow = function (question) {
                    return question.answer.value == null && question.allow_dynamic_addition;
                }

                scope.dynamicDisabled = function (question) {
                    return (question.answer.value != null && (question.allow_dynamic_addition || question.allow_dynamic_edit));
                }

                scope.childServiceDisabled = function (question) {
                    return (scope.group.component_data_set_code == 'service_relationships' && question.parameters.child_service == true);
                }

                scope.actionChanged = function (group, question) {
                    if ((group.single_group_action == 'undefined' && scope.previousAction != '') || (group.single_group_action == 'a' && scope.previousAction != '' && scope.previousAction != 'a') || (group.single_group_action != 'a' && scope.previousAction == 'a')) {
                        // The question that's been sent in is the service_user_vehicle_id or service_user_user_id
                        // We need to clear it and everything under it, as though the user cleared it.
                        question.answer.value = null;
                        question.answer.show_value = null;
                        scope.previousAction = group.single_group_action;
                        // This clears out everything under the User or Vehicle
                        // and the service_user/service_vehicle questions
                        scope.answerChanged(question);
                        // The question record is cleared, but the inner form text remains.

                    }
                    else {
                        scope.previousAction = group.single_group_action;
                    }
                }

                scope.setupAddress = function (question) {
                    if (!scope.locationIntegrationEnabled) {
                        question.address = {};
                        // Get the questions for the address tied to this postal code question
                        scope.group.questions.forEach(function (q) {
                            if (q.data_point_address_field != null && (q.data_point_address_field != 'postal_code' && q.data_point_address_field != 'location_name' && q.data_point_address_field != 'location_number' && q.data_point_address_field != 'latitude' && q.data_point_address_field != 'longitude') && q.data_point_address_postal_data_point_id == scope.question.data_point_id) {
                                question.address[q.data_point_address_field] = q;
                            }
                        });
                    }
                }

                scope.setupIntegrationAddress = function (question) {
                    if (scope.locationIntegrationEnabled) {
                        question.address = {};
                        // Get the questions for the address tied to this postal code question
                        scope.group.questions.forEach(function (q) {
                            if (q.data_point_address_field != null && q.data_point_address_field != 'street_1' && q.data_point_address_postal_data_point_id == question.data_point_address_postal_data_point_id) {
                                question.address[q.data_point_address_field] = q;
                            }
                        });
                    }
                }

                // Custom validation functions for some questions - scope.parameters.service_id != null added to not limit positions in user/service affiliations because it was being done incorrectly [Bug 173688] //
                scope.requiredPositions = [];
                if (scope.question.data_point_code === 'service_users_position' && scope.parameters.service_id !== null && scope.group.component_data_set_code !== 'service_user_changes') {
                    if (scope.question.validation == null) {
                        scope.question.validation = {};
                    }
                    scope.question.validation.function = function () {
                        var d = $q.defer();
                        scope.$evalAsync(function () {
                            scope.requiredPositions = [];
                            // if this is the positions question for service users, we need a count of each position on the form, and we need to hide or force positions so as to meet the min/max settings for the positions. 
                            // Build a list of all selected positions as they are 
                            var positionsAnswers = scope.datapointAnswers['service_users_position'];
                            if (typeof positionsAnswers != 'undefined' && positionsAnswers != null) {
                                var positionsOnForm = [];
                                positionsAnswers.forEach(function (positionAnswer) {
                                    if (typeof (positionAnswer.value) == "string") {
                                        var values = positionAnswer.value != null ? positionAnswer.value.split(',') : null;
                                        var newValues = [];
                                        values.forEach(function (val) {
                                            newValues.push({ id: val });
                                        });
                                        if (newValues != null && newValues.length > 0) {
                                            positionsOnForm.push.apply(positionsOnForm, newValues);
                                        }
                                    } else {
                                        if (positionAnswer.value != null && positionAnswer.value.length > 0) {
                                            positionAnswer.value.forEach(function (val) {
                                                positionsOnForm.push({ id: (val != null && typeof val === 'object') ? val.id : val });
                                            });
                                        }
                                    }
                                });
                            }

                            if (scope.question.options != null) {
                                // turn comma-separated list into array of objects so we can add hidden flag if need be. 
                                var tempOptions = scope.question.options;
                                if (Object.prototype.toString.call(scope.question.options) !== '[object Array]') {
                                    var tempOptions = [];
                                    scope.question.options.split(',').forEach(function (option) {
                                        tempOptions.push({ id: option.trim(), name: option.trim() });
                                    });
                                }
                                // loop through the position options, and check how many of each there are (only forced on Multiple Allowed #)
                                tempOptions.forEach(function (position) {
                                    var positionCount = positionsOnForm.filter(function (x) { return x.id == position.id }).length;

                                    var minimumMet = true;
                                    if (scope.group.component_allow_multiple_groups === true) {
                                        minimumMet = position.min == null || positionCount >= position.min;
                                    }

                                    if (!minimumMet) {
                                        position.hide = false;
                                        scope.requiredPositions.push(position);
                                    }
                                    else if (position.max != null && positionCount >= position.max) {
                                        position.hide = true;
                                    }
                                    else {
                                        position.hide = false;
                                    }
                                });
                                scope.question.options = tempOptions;

                                if (scope.requiredPositions.length > 0) {
                                    d.resolve(false);
                                }
                                else {
                                    d.resolve(true);
                                }
                            }
                            else {
                                d.resolve(true);
                            }
                        });
                        return d.promise;
                    }
                }
                if (scope.question.answer.data_point_code == 'certification_expiration_date' && scope.question.answer.value == null && scope.question.default_value != null) {
                    scope.question.answer.value = scope.question.default_value;
                }

                if (scope.question.data_point_code == 'user_training_training_id') {
                    scope.question.retrieveCourseInfo = function (question) {
                        if (question.answer != null) {
                            if (question.answer.value != null) {
                                Trainings.getByID(question.answer.value).then(function (courseInfo) {
                                    question.courseInfo = courseInfo;
                                    if (question.courseInfo.attendee_count == null) { question.courseInfo.attendee_count = 0 }
                                    if (question.courseInfo.attendee_max_count != null) {
                                        question.courseInfo.remainingSpots = Math.max(question.courseInfo.attendee_max_count - question.courseInfo.attendee_count, 0);
                                    }
                                    question.address = "";
                                    if (question.courseInfo.locationinfo != null && question.courseInfo.locationinfo.length > 0) {
                                        if (question.courseInfo.locationinfo[0].street1 != null) { question.address = question.address + ", " + question.courseInfo.locationinfo[0].street1 }
                                        if (question.courseInfo.locationinfo[0].street2 != null) { question.address = question.address + ", " + question.courseInfo.locationinfo[0].street2 }
                                        if (question.courseInfo.locationinfo[0].municipality != null) { question.address = question.address + ", " + question.courseInfo.locationinfo[0].municipality }
                                        if (question.courseInfo.locationinfo[0].regioninfo != null && question.courseInfo.locationinfo[0].regioninfo.length > 0 && question.courseInfo.locationinfo[0].regioninfo[0].abbreviation != null) { question.address = question.address + ", " + question.courseInfo.locationinfo[0].regioninfo[0].abbreviation }
                                        if (question.courseInfo.locationinfo[0].postal_code != null) { question.address = question.address + ", " + question.courseInfo.locationinfo[0].postal_code }
                                    }
                                    question.address = question.address.substring(1);
                                });
                            }
                        }
                    }
                    scope.question.retrieveCourseInfo(scope.question);
                    if (scope.question.validation == null) {
                        scope.question.validation = {};
                    }
                    scope.question.validation.function = function () {
                        var d = $q.defer();
                        scope.$evalAsync(function () {
                            if (scope.question.answer.value != null) {
                                Trainings.checkPrerequisites(scope.question.answer.value, $rootScope.userID).then(function (failedPrerequisites) {
                                    if (failedPrerequisites == true) {
                                        scope.question.validation.customFunctionMessage = "You do not meet the course prerequisite requirements.";
                                        d.resolve(false);
                                    } else {
                                        if (scope.question.courseInfo.attendee_max_count != null && scope.question.courseInfo.attendee_count != null && scope.question.courseInfo.attendee_count >= scope.question.courseInfo.attendee_max_count) {
                                            scope.question.validation.customFunctionMessage = "This course has reached its maximum capacity.";
                                            d.resolve(false);
                                        }
                                        else {
                                            d.resolve(true);
                                        }
                                    }
                                });
                            }
                            else { d.resolve(true); }
                        });
                        return d.promise;
                    }
                }
                if (scope.question.data_point_code == 'vehicle_certification_number') {
                    if (scope.question.validation == null) {
                        scope.question.validation = {};
                    }
                    scope.question.validation.function = function () {
                        var d = $q.defer();
                        scope.$evalAsync(function () {
                            var permitNumber = scope.question.answer ? scope.question.answer.value : "";
                            var vehicleID = scope.group.vehicle_id || scope.group.record_id || null;
                            if (permitNumber !== undefined && permitNumber != null && permitNumber != "") {
                                // See if this is a duplicate permit number 
                                Vehicles.getCertificationByNumber(permitNumber, vehicleID).then(function (result) {
                                    if (result.length > 0) {
                                        scope.question.validation.customFunctionMessage = "There is already a vehicle with this permit number.";
                                        d.resolve(false);
                                    }
                                    else {
                                        // check vehicles we just added 
                                        var permitNumberCount = scope.datapointAnswers.vehicle_certification_number.filter(function (vcn) {
                                            return (vcn.value == permitNumber && vcn.has_content == true);
                                        }).length;

                                        // more than 1 from above reduce means there are duplicate certification numbers added in the form, throw validation error 
                                        if (permitNumberCount > 1) {
                                            scope.question.validation.customFunctionMessage = "You may not add two vehicles with the same permit number: " + permitNumber;
                                            d.resolve(false);
                                        }
                                        else {
                                            d.resolve(true);
                                        }
                                    }
                                });
                            }
                            else { d.resolve(true); }
                        });
                        return d.promise;
                    }
                }
                if (scope.question.data_point_code == 'vehicle_serial_number') {
                    if (scope.question.validation == null) {
                        scope.question.validation = {};
                    }
                    scope.question.validation.function = function () {
                        var d = $q.defer();
                        scope.$evalAsync(function () {
                            var serialNumber = scope.question.answer ? scope.question.answer.value : "";
                            var vehicleID = scope.group.vehicle_id || scope.group.record_id || null;
                            if (serialNumber !== undefined && serialNumber != null && serialNumber != "") {
                                // See if this is a duplicate permit number 
                                Vehicles.getVehicleBySerialNumber(serialNumber, vehicleID).then(function (result) {
                                    if (result.length > 0) {
                                        scope.question.validation.customFunctionMessage = "There is already a vehicle with this serial number.";
                                        d.resolve(false);
                                    }
                                    else {
                                        // check vehicles we just added 
                                        var serialNumberCount = scope.datapointAnswers.vehicle_serial_number.filter(function (vsn) {
                                            return (vsn.value == serialNumber && vsn.has_content == true);
                                        }).length;

                                        // more than 1 from above reduce means there are duplicate serial numbers added in the form, throw validation error 
                                        if (serialNumberCount > 1) {
                                            scope.question.validation.customFunctionMessage = "You may not add two vehicles with the same serial number: " + serialNumber;
                                            d.resolve(false);
                                        }
                                        else {
                                            d.resolve(true);
                                        }
                                    }
                                });
                            }
                            else { d.resolve(true); }
                        });
                        return d.promise;
                    }
                }
                if (scope.question.data_point_code == 'user_email') {
                    if (scope.question.validation == null) {
                        scope.question.validation = {};
                    }
                    scope.question.validation.function = function () {
                        var d = $q.defer();
                        scope.$evalAsync(function () {
                            var email = scope.question.answer ? scope.question.answer.value : "";
                            var userID = scope.group.user_id || scope.group.record_id || null;
                            if (email !== undefined && email != null && email != "") {
                                // See if this is a duplicate email 
                                Users.getUserbyEmail(email, userID).then(function (result) {
                                    if (result.length > 0) {
                                        scope.question.validation.customFunctionMessage = "There is already a user with this email.";
                                        d.resolve(false);
                                    }
                                    else {
                                        // a form with data point 'user_email' belongs to a single user, so do not throw validation error if same email is present more than once in the form
                                        d.resolve(true);
                                    }
                                });
                            }
                            else {
                                d.resolve(true);
                            }
                        });
                        return d.promise;
                    }
                }
                if (scope.question.data_point_code == 'calendar_year') {
                    if (scope.question.validation == null) {
                        scope.question.validation = {};
                    }
                    scope.question.validation.function = function () {
                        var d = $q.defer();
                        scope.$evalAsync(function () {
                            var year = scope.question.answer ? scope.question.answer.value : "";

                            if (year !== undefined && year != null && year != "") {
                                // Make sure there are no duplicate years
                                var yearCount = scope.datapointAnswers.calendar_year.filter(function (vsn) {
                                    return (vsn.value == year && vsn.has_content == true);
                                }).length;
                                // more than 1 from above reduce means there are duplicate years added in the form, throw validation error
                                if (yearCount > 1) {
                                    scope.question.validation.customFunctionMessage = "You may not add two statistics with the same year: " + year;
                                    d.resolve(false);
                                }
                                else {
                                    d.resolve(true);
                                }
                            }
                            else {
                                d.resolve(true);
                            }
                        });
                        return d.promise;
                    }
                }

                if (scope.question.data_point_code == 'service_users_personnel_id') {
                    if (scope.question.validation == null) {
                        scope.question.validation = {};
                    }
                    scope.question.validation.function = function () {
                        var d = $q.defer();

                        scope.$evalAsync(function () {
                            var personnelID = scope.question.answer ? scope.question.answer.value : "";
                            var serviceID = scope.group.service_id || scope.parameters.service_id || null;
                            var userID = scope.group.user_id || scope.parameters.user_id || null;
                            for (var i = 0; i < scope.group.questions.length; i++) {
                                if (scope.group.questions[i].data_point_code == 'service_users_user_id' && scope.group.questions[i].answer.value !== null) {
                                    userID = scope.group.questions[i].answer.value; //user on form
                                }
                            }
                            if (personnelID !== undefined && personnelID != null && personnelID != "" && serviceID !== undefined && serviceID != null) {
                                // See if this is a duplicate personnelID in the service
                                Users.getUserByServicePersonnelID(personnelID, serviceID).then(function (result) {
                                    if (result.length > 0) {
                                        var coreRosterUser = result[0].user_id;
                                        if (userID !== coreRosterUser) {
                                            scope.question.validation.customFunctionMessage = "The Personnel ID entered is already taken by a user in this Service.";
                                            d.resolve(false);
                                        }
                                        else {
                                            d.resolve(true);
                                        }
                                    }
                                    else {
                                        // check PersonnelID we just added
                                        var userCount = scope.datapointAnswers.service_users_personnel_id.filter(function (sup) {
                                            return (sup.value == personnelID && sup.has_content == true);
                                        }).length;
                                        if (userCount > 1) {
                                            scope.question.validation.customFunctionMessage = "The Personnel ID entered is already taken by a user in this Service.";
                                            d.resolve(false);
                                        }
                                        else {
                                            d.resolve(true);
                                        }
                                    }
                                });
                            }
                            else {
                                d.resolve(true);
                            }
                        });
                        return d.promise;
                    }
                }
                // End custom validation functions //

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).off(); // deregister all event handlers 
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            },
            controller: ['$scope', '$uibModal', 'FBResponses', 'ServiceAreaCities', 'ServiceAreaCounties', 'ServiceAreaPostalCodes', 'ServiceAreaCensusTracts', 'Format', '$filter', '$injector', '$q', '$rootScope', 'IPComment', 'Positions', 'Documents', function ($scope, $uibModal, FBResponses, ServiceAreaCities, ServiceAreaCounties, ServiceAreaPostalCodes, ServiceAreaCensusTracts, Format, $filter, $injector, $q, $rootScope, IPComment, Positions, Documents) {
                $scope.isPortal = $rootScope.isPortal.toLowerCase() === 'true';
                $scope.showReviewComment = false;
                $scope.showDynamicComment = false;
                $scope.currComment = "";
                if ($scope.question.question_type.code === 'number' && $scope.question.answer.value && typeof ($scope.question.question_type.code) !== 'number') { $scope.question.answer.value = Number($scope.question.answer.value); }

                // Get comments for Inspection Checklist
                if ($scope.inspectionChecklist != null && $scope.inspectionChecklist.administrative_review === true && $scope.question.id != null && $scope.inspectionChecklist.inspectionID != null && $scope.inspectionChecklist.comments === undefined) {
                    IPComment.getAdministrativeCommentsByQuestionId($scope.question.id, $scope.inspectionChecklist.inspectionID).then(function (comments) {
                        $scope.comments = comments;
                        // Update createdon & createdby to work with hlp-edit-history
                        for (var i = 0; i < $scope.comments.length; i++) {
                            $scope.comments[i].createdon = $scope.comments[i].createdOn;
                            $scope.comments[i].createdby = $scope.comments[i].fullName;
                        }
                    });
                    // Comments are passed in, assign correct comments to this question (generatePDF)
                } else if ($scope.inspectionChecklist != null && $scope.inspectionChecklist.comments !== undefined) {
                    const questionId = $scope.question.id;
                    $scope.comments = [];

                    for (var i = 0; i < $scope.inspectionChecklist.comments.records.length; i++) {
                        if (questionId === $scope.inspectionChecklist.comments.records[i].fbQuestionId) {
                            $scope.comments.push($scope.inspectionChecklist.comments.records[i]);
                        }
                    }
                }

                $scope.setAutoCompleteByDisabled = function (isDisabled) {
                    if (isDisabled) {
                        /* This set autoComplete to a dummy string "auto-complete-off", so it doesn't mapping
                           the field to any of auto-complete field saved in the browser. This effectively turn
                           off the auto-fill from browser feature. We do this because html attribute
                           autocomplete="off" isn't work as expected.
                        */
                        return "auto-complete-off"
                    }
                }

                // Open Review comment box
                $scope.toggleReviewComment = function () {
                    $scope.showReviewComment = !$scope.showReviewComment;
                };

                // Open original comment box
                $scope.toggleDynamicComment = function () {
                    $scope.showDynamicComment = !$scope.showDynamicComment;
                };
                $scope.enableAdminComments = function () {
                    if ($scope.inspectionChecklist != null && $scope.inspectionChecklist.administrative_review == 1 && !$scope.isPortal && $scope.inspectionChecklist.inspectionID != null) {
                        return true;
                    }
                    return false;
                }
                $scope.enableAdminReply = function () {
                    if ($scope.inspectionChecklist != null && $scope.inspectionChecklist.administrative_review == 1 && $scope.isPortal && $scope.inspectionChecklist.inspectionID != null && $scope.comments != null && Array.isArray($scope.comments) && $scope.comments.length > 0) {
                        return true;
                    }
                    return false;
                }

                $scope.saveReviewComment = function () {
                    var comment = $scope.currComment;

                    if (comment) {
                        IPComment.saveAdministrativeComment(comment, $scope.question.id, $scope.inspectionChecklist.inspectionID).then(function (response) {
                            $scope.currComment = ''; // reset comment box

                            // After saving comment, update the deficency for comments
                            IPComment.getAdministrativeCommentsByQuestionId($scope.question.id, $scope.inspectionChecklist.inspectionID).then(function (comments) {
                                $scope.comments = comments;
                            });
                        });
                    }
                };

                $scope.resolveComment = function (id, comment) {
                    IPComment.resolveAdministrativeComment(id, comment).then(function (resolve) {
                        // After resolving comment, update the deficency for comments
                        IPComment.getAdministrativeCommentsByQuestionId($scope.question.id, $scope.inspectionChecklist.inspectionID).then(function (comments) {
                            $scope.comments = comments;
                        });
                    });
                    comment.resolved = true;
                };

                $scope.toggleShowOnPdf = function (id, comment) {
                    IPComment.toggleShowOnPdf(id, comment).then(function (response) {

                    });
                };

                // for images 
                $scope.openImageModal = function (question) {
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'templates/photo-upload/photo-upload.html',
                        controller: 'PhotoUploadModalController',
                        resolve: {
                            file_content: function () {
                                return question.answer.file_content;
                            }
                        }
                    }).result.then(function (upload) {
                        if (upload != null) {
                            if (upload.document_id != null) {
                                // File uploaded directly to blob storage - associate the document with the answer.
                                Documents.getByID(upload.document_id).then(function (file) {
                                    question.answer.file_name = file.file_name;
                                    question.answer.document_name = file.name;
                                    question.answer.document_id = file.id;
                                    question.answer.document_code = file.code;
                                    question.answer.document_type = file.document_type_id;
                                    question.answer.document_description = file.description;
                                    question.answer.file_updated = upload.is_new_upload === true;
                                    question.answer.file_content = null;
                                });
                            }
                            else {
                                question.answer.file_content = upload.file_content;
                                question.answer.file_name = upload.file_name;
                                question.answer.file_updated = true;
                            }
                        }
                    });
                }

                $scope.showServiceRosterList = function (question) {

                    if ((question.data_point_code == 'service_users_user_id' || question.data_point_code == 'service_vehicles_vehicle_id') && $scope.group.component_allow_multiple_groups != "undefined" && $scope.group.component_allow_multiple_groups != null && ($scope.group.component_allow_multiple_groups == false || $scope.group.component_data_set_code == 'service_user_changes')) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

                $scope.applicationTypeExists = function (question) {
                    var exists = false;

                    if (question.data_point_code == 'certification_levels') {
                        $scope.group.questions.forEach(function (q) {
                            if (q.question_type.code == 'application_type') {
                                exists = true;
                            }
                        })
                    }

                    return exists;
                }

                $scope.clearQuestion = function (question) {
                    question.answer.value = null;
                    question.answer.show_value = null;
                    if (question.options != null) {
                        for (var i = 0; i < question.options.length; i++) {
                            if (question.options[i].checked != null) {
                                question.options[i].checked = false;
                            }
                        };
                    }
                }

                $scope.numberCheck = function (keyEvent) {
                    if (isNaN(keyEvent.key) || keyEvent.key === ' ' || keyEvent.key === '') {
                        keyEvent.returnValue = '';
                    }
                }

                $scope.stateChanged = function (question) {

                    var stateCode = question.answer.value;
                    var newState = 0;

                    if (stateCode != null) {
                        if ($scope.group.stateCode != undefined && $scope.group.stateCode != null && $scope.group.stateCode != stateCode) {
                            newState = 1;
                        }
                        $scope.group.stateCode = stateCode;

                        $scope.group.questions.forEach(function (datasetquestion) {
                            //If this is a state CHANGE then we'll reinitialize the questions below the state
                            if (newState == 1 && (datasetquestion.data_point_code == 'service_area_cities'
                                || datasetquestion.data_point_code == 'service_area_counties'
                                || datasetquestion.data_point_code == 'service_area_postal_codes'
                                || datasetquestion.data_point_code == 'service_area_censustracts')) {

                                $scope.clearQuestion(datasetquestion);

                                if (datasetquestion.data_point_code == 'service_area_cities') {
                                    ServiceAreaCities.getByStateCode(stateCode).then(function (data) {
                                        datasetquestion.dirOptions = data;
                                        datasetquestion.options = data;
                                        $scope.initQuestion(datasetquestion);
                                    });
                                }
                                if (datasetquestion.data_point_code == 'service_area_counties') {
                                    ServiceAreaCounties.getByStateCode(stateCode).then(function (data) {
                                        datasetquestion.dirOptions = data;
                                        datasetquestion.options = data;
                                        $scope.initQuestion(datasetquestion);
                                    });
                                }
                                if (datasetquestion.data_point_code == 'service_area_postal_codes') {
                                    ServiceAreaPostalCodes.getByStateCode(stateCode).then(function (data) {
                                        datasetquestion.dirOptions = data;
                                        datasetquestion.options = data;
                                        $scope.initQuestion(datasetquestion);
                                    });
                                }
                                if (datasetquestion.data_point_code == 'service_area_censustracts') {
                                    ServiceAreaCensusTracts.getByStateCode(stateCode).then(function (data) {
                                        datasetquestion.dirOptions = data;
                                        datasetquestion.options = data;
                                        $scope.initQuestion(datasetquestion);
                                    });
                                }
                            }
                        });
                    }
                }

                $scope.answerChanged = function (question) {
                    //The question here has subcomponent questions that already hold the previous vehicle/user answers and they're not clearing out consistently
                    //within the populateSubComponent function if the new one doesn't have a value. I've tried everything I can think of and it's not working
                    //Since we know the value has changed, or it wouldn't have gotten in here, let's clear all the answers up front
                    if ((question.data_point_code == 'service_users_user_id' || question.data_point_code == 'service_vehicles_vehicle_id') && ($scope.group.component_allow_multiple_groups == false || $scope.group.component_data_set_code == 'service_user_changes')) {
                        if (question.sub_components != null && question.sub_components.length > 0) {
                            question.sub_components[0].groups[0].questions.forEach(function (subQuestion) {
                                if (subQuestion != null && subQuestion.answer != null) {
                                    subQuestion.loading = true;
                                    subQuestion.answer.value = null;
                                    subQuestion.answer.show_value = null;
                                }
                            });
                        }
                    }

                    $scope.populateSubComponent(question).then(function () {
                        if (question.data_point_foreign_data_set_code != null && question.sub_components != null && question.sub_components.length > 0 && question.sub_components[0] != null && question.sub_components[0].groups != null &&
                            question.sub_components[0].groups.length > 0 && question.sub_components[0].groups[0] != null && question.sub_components[0].groups[0].questions != null) {
                            question.sub_components[0].groups[0].questions.forEach(function (q) {
                                if (q != null) {
                                    q.refreshValidation = true;
                                }
                            });
                        }
                    });

                    if (question.data_point_code == 'user_training_training_id') {
                        question.retrieveCourseInfo(question);
                    }

                    if ((question.data_point_code == 'service_users_user_id' || question.data_point_code == 'service_vehicles_vehicle_id') && ($scope.group.component_allow_multiple_groups == false || $scope.group.component_data_set_code == 'service_user_changes')) {
                        var d = $q.defer();

                        //clear out the previous answers
                        $scope.group.questions.forEach(function (datasetquestion) {
                            //If this is the user or the vehicle question, don't clear the answer value
                            if (datasetquestion.name != 'User' && datasetquestion.name != 'Vehicle') {
                                $scope.clearQuestion(datasetquestion);
                            }
                        });

                        // This will update the service user/service vehicle fields.  The user/vehicle fields were already being filled in by the sub_component update above.
                        FBResponses.populateGroup($scope.group.component_data_set_code, question.answer.value, $scope.parameters.service_id, $scope.group.component_data_set_code == 'service_user_changes' ? true : !$scope.group.component_allow_multiple_groups).then(function (data) {
                            if (data != null) {
                                $scope.group.questions.forEach(function (datasetquestion) {
                                    // don't bother if it's the service_users_user_id question or the service_vehicles_vehicle_id question, because that one's already populated.
                                    if (datasetquestion.data_point_code != question.data_point_code && datasetquestion != null && datasetquestion.answer != null) {
                                        if (data[datasetquestion.data_point_code] instanceof Date) {
                                            datasetquestion.answer.value = Format.convertDateToUTC(data[datasetquestion.data_point_code]);
                                        }
                                        else {
                                            if (datasetquestion.data_point_code === "service_users_position") {
                                                datasetquestion.answer.value = (data[datasetquestion.data_point_code]) ? data[datasetquestion.data_point_code].split(',') : null;
                                                $scope.group.questions[$scope.group.hasPositions].original_value = angular.copy(datasetquestion.answer.value);
                                            } else {
                                                datasetquestion.answer.value = data[datasetquestion.data_point_code];
                                            }
                                        }
                                        if (data[datasetquestion.data_point_code] == null) {
                                            datasetquestion.answer.value = null;
                                            datasetquestion.answer.show_value = null;
                                            $scope.clearQuestion(datasetquestion);

                                        }
                                    }
                                });
                            }
                            d.resolve(true);
                        });
                    }
                }

                $scope.populateSubComponent = function (question) {
                    var d = $q.defer();
                    if (question.data_point_foreign_data_set_code != null && question.sub_components != null && question.sub_components.length > 0 && question.sub_components[0] != null && question.sub_components[0].groups != null &&
                        question.sub_components[0].groups.length > 0 && question.sub_components[0].groups[0] != null && question.sub_components[0].groups[0].questions != null) {

                        if (question.answer.value == null) {
                            question.sub_components[0].groups[0].questions.forEach(function (question) {
                                if (question != null && question.answer != null) {
                                    question.answer.value = null;
                                }
                            });
                            d.resolve(true);
                        }
                        else {
                            question.sub_components[0].loading = true;
                            question.sub_components[0].groups[0].record_id = question.answer.value;
                            FBResponses.populateGroup(question.data_point_foreign_data_set_code, question.answer.value, $scope.parameters.service_id, false).then(function (data) {
                                if (data != null) {
                                    question.sub_components[0].groups[0].questions.forEach(function (question) {
                                        if (question != null && question.answer != null && data[question.data_point_code] != null) {
                                            if (data[question.data_point_code] instanceof Date) {
                                                question.answer.value = Format.convertDateToUTC(data[question.data_point_code]);
                                            }
                                            else {
                                                question.answer.value = data[question.data_point_code];
                                                if (data[question.data_point_code] == null) {
                                                    question.answer.value = null;
                                                    question.answer.show_value = null;
                                                }
                                            }
                                        }
                                    });
                                }
                                question.loading = false;
                                question.sub_components[0].loading = false;
                                d.resolve(true);
                            });
                        }
                    }
                    else {
                        d.resolve(true);
                    }
                    return d.promise;
                }

                $scope.filterOptions = function () {
                    var promises = [];
                    var opts = $scope.question.originalOptions;
                    $scope.question.filters.forEach(function (filter) {
                        if (filter != null && filter.value != null || filter.data_point_code == "service_users_classification" || filter.data_point_code == "service_users_county") {
                            if ($scope.question.data_point_code == "service_users_certification_level") {
                                if ($scope.question.custom_filter) {
                                    var service = $injector.get($scope.question.service);
                                    var params = angular.copy($scope.question.parameters);
                                    params.filter = true;
                                    params.service_id = filter.value;
                                    promises.push(service[$scope.question.method](params).then(function (data) {
                                        if (data != null) {
                                            opts = data;
                                        }
                                    }));
                                }
                            }
                            else {
                                switch (filter.data_point_code) {
                                    case 'service_users_classification':
                                        opts = $filter('classification')(opts, filter.value, 'classification');
                                        break;
                                    case 'service_users_county':
                                        // Only done for County Filter for Maryland's SOW
                                        opts = $filter('county')(opts, filter.value, 'county');
                                        var newOpts = [];
                                        opts.forEach(function (opt) {
                                            if (opt.children !== undefined) {
                                                var childAdded = false;
                                                opt.children.forEach(function (child) {
                                                    if (!child.disable) {
                                                        // Add parent on first child added
                                                        if (!childAdded) newOpts.push(opt);
                                                        newOpts.push(child);
                                                        childAdded = true;
                                                    }
                                                });
                                                // No Children, add service though
                                                if (!opt.disable && !childAdded) newOpts.push(opt);
                                            }
                                        });
                                        opts = newOpts;
                                        break;
                                    default:
                                        opts = $filter('filter')(opts, filter.value);
                                        break;
                                }
                            }
                        }
                    });

                    $q.all(promises).then(function () {
                        $scope.question.options = opts;
                    }).catch(function (response) {
                        // handle error
                    });;
                }

                $scope.initQuestion = function (question) {
                    // Initialize deficiency score
                    if (question.deficiency.score != 'undefined' && typeof question.deficiency.score == 'number') {
                        if (question.answer.fail != null) {
                            if (question.answer.fail == 0) {
                                $scope.deficiencyScore.score += question.deficiency.score;
                            }
                        }
                    }

                    if ($scope.group.parameters != null) {
                        question.parameters = angular.copy($scope.group.parameters);
                    } else {
                        question.parameters = angular.copy($scope.parameters);
                    }

                    if (question.data_point_code != null && question.data_point_code != '') {
                        question.filters = [];
                        $scope.group.questions.forEach(function (q) {
                            if (question.data_point_code == q.filter_data_point_code) {
                                question.filters.push(q.answer);
                            }
                        })

                        if (question.filters.length > 0) {
                            $scope.$watch('question.filters', function () {
                                if ($scope.question.originalOptions != null) {
                                    $scope.filterOptions();
                                }
                            }, true)

                            if (question.options == null) {
                                $scope.$watch('question.options', function () {
                                    if ($scope.question.options != null && $scope.question.originalOptions == null) {
                                        $scope.question.originalOptions = $scope.question.options;
                                        $scope.filterOptions();
                                    }
                                }, true)
                            }
                            else {
                                question.originalOptions = question.options;
                            }
                        }

                        //Avoid browser autofill
                        if (question.data_point_code == 'service_name') {
                            question.name = 'serviceName';
                        }
                        else if (question.data_point_code == 'service_owner_name') {
                            question.name = 'serviceOwnerName';
                        }

                        if (question.data_point_code == 'user_training_training_id' && question.answer != null && question.answer.value != null && isValidGuid(question.answer.value)) {
                            question.parameters.current_training_id = question.answer.value;
                        }

                        if (question.data_point_code == 'service_vehicles_vehicle_id' && question.vehicle_restrict_services == true) {
                            $scope.group.parameters.vehicle_restrict_services = true;
                        }

                        if (question.data_point_code == 'service_area_states' && question.answer != "undefined" && question.answer != null && question.answer.value != null) {
                            $scope.stateChanged(question);
                        }

                        if ((question.data_point_code == 'service_users_user_id' || question.data_point_code == 'service_vehicles_vehicle_id') && $scope.group.component_allow_multiple_groups != "undefined" && $scope.group.component_allow_multiple_groups != null && ($scope.group.component_allow_multiple_groups == false || $scope.group.component_data_set_code == 'service_user_changes')) {

                            $scope.actionOptions = [];

                            if ($scope.group.component_group_add == true) {
                                $scope.actionOptions = [{ id: 'a', name: 'Add record to the service' }];
                                if ($scope.group.component_group_update == true) {
                                    $scope.actionOptions = [
                                        { id: 'a', name: 'Add record to the service' },
                                        { id: 'u', name: 'Update record in the service' }];
                                    if ($scope.group.component_group_remove == true) {
                                        $scope.actionOptions = [
                                            { id: 'a', name: 'Add record to the service' },
                                            { id: 'u', name: 'Update record in the service' },
                                            { id: 'r', name: 'Remove record from the service' }];
                                    }
                                }
                                else if ($scope.group.component_group_remove == true) {
                                    $scope.actionOptions = [
                                        { id: 'a', name: 'Add record to the service' },
                                        { id: 'r', name: 'Remove record from the service' }];
                                }
                            }
                            else {
                                if ($scope.group.component_group_update == true) {
                                    $scope.actionOptions = [{ id: 'u', name: 'Update record in the service' }];
                                    if ($scope.group.component_group_remove == true) {
                                        $scope.actionOptions = [
                                            { id: 'u', name: 'Update record in the service' },
                                            { id: 'r', name: 'Remove record from the service' }];
                                    }
                                }
                                else if ($scope.group.component_group_remove == true) {
                                    $scope.actionOptions = [{ id: 'r', name: 'Remove record from the service' }];
                                }
                            }
                        }
                    }
                }

                // Used on continue & save so it doesn't error, would read value as a string.
                // service_financials number fields (fiscal year, total revenue, total income, other income)
                const financialNumberIds = ["b50c8157-489f-4a2b-bf76-3023e2c39710", "ef1a6290-8cf9-42cf-9863-ed2802d836fe", "227be11c-1f70-4194-9d6a-000507882729", "3317f3bd-f560-4c02-836d-c03e9cb6ceae"];
                $scope.$watch('question.answer', function (newValue, oldValue) {
                    if (financialNumberIds.includes(newValue.data_point_id) && newValue.value !== oldValue.value) {
                        $scope.question.answer.value = parseFloat(newValue.value);
                    }
                });

                // for deficiency 
                $scope.parentDeficiencies = 0;
                $scope.counter = function (deficiency) {
                    deficiency.list_count = ++$scope.count;
                }

                if ($scope.group.questions !== undefined && $scope.group.questions.length > 0) {
                    var iter = 0;
                    $scope.group.questions.forEach(function (q) {
                        if (q.data_point_id === '3c9ae5ea-c8d6-4656-80d9-1b2242b0cbe2') { // service_users_service id
                            $scope.group.hasService = iter;
                        }
                        if (q.data_point_id === 'ba99ae16-280a-4fe5-9dd1-755e03733ded') { // service_users_position id
                            $scope.group.hasPositions = iter;
                            $scope.group.questions[iter].original_value = "";
                        }
                        if (q.data_point_id === '36efca21-228e-4e15-b085-8f1a74df7c21') { // service_users_user_id id
                            $scope.group.hasUser = iter;
                        }
                        iter++;
                    });
                }

                // 81739: add watch if (provider data set "service affiliation") service & position are on form, connected by group (data set).
                if ($scope.group.hasPositions !== undefined) {
                    if ($scope.group.component_allow_multiple_groups === true && $scope.groups.length === 1) { $scope.group.edit = true; }

                    // Ensures we keep selected values and (preloaded) original values togglable when position is full
                    if (($scope.group.questions[$scope.group.hasPositions].answer.value || $scope.group.position_original_value !== undefined) && ($scope.group.questions[$scope.group.hasPositions].original_value.length === 0)) {
                        $scope.group.questions[$scope.group.hasPositions].original_value = ($scope.group.position_original_value !== undefined) ? $scope.group.position_original_value : $scope.group.questions[$scope.group.hasPositions].answer.value;
                        if ($scope.group.position_original_value === undefined) $scope.group.position_original_value = $scope.group.questions[$scope.group.hasPositions].original_value;
                    }

                    $scope.$watch('question.answer.value', function (newValue, oldValue) {
                        // Service switched, reset position values
                        if ($scope.question === $scope.group.questions[$scope.group.hasService] && newValue != oldValue) {
                            $scope.group.questions[$scope.group.hasPositions].answer.value = null;
                            $scope.group.questions[$scope.group.hasPositions].answer.show_value = null;
                        }

                        // Switching user will reset original_value
                        if (newValue === null) { $scope.group.questions[$scope.group.hasPositions].original_value = null; }

                        // When new answer added, add only ID instead of whole object
                        if (newValue && newValue !== oldValue && newValue.length - 1 >= 0 && typeof (newValue[newValue.length - 1]) !== 'string') {
                            if (typeof ($scope.group.questions[$scope.group.hasPositions].answer.value) === 'string') {
                                $scope.group.questions[$scope.group.hasPositions].answer.value += (',' + newValue[newValue.length - 1].id);
                            }
                            else {
                                newValue[newValue.length - 1] = newValue[newValue.length - 1].id;
                            }
                        }

                        var service_id = '';
                        if (newValue !== null && newValue !== undefined) {
                            if ($scope.group.hasService !== undefined && $scope.group.questions[$scope.group.hasService].answer.value === newValue) {
                                service_id = newValue;
                            } else if ($scope.group.hasUser !== undefined && $scope.group.questions[$scope.group.hasUser].answer.value === newValue && $scope.group.hasUser > $scope.group.hasPositions) {
                                service_id = $scope.parameters.service_id;
                            }

                            // This should only be called from service affiliation, service users will share the same available positions.
                            if (service_id !== '' && ($scope.group.edit === true || $scope.group.single_group_action !== null) && ($scope.group.hasService !== undefined || $scope.groups.length === 1)) {
                                Positions.getServiceDesignation({ service_id: service_id, limit_position_ids: $scope.group.parameters.limit_position_ids }).then(function (positions) {
                                    $scope.group.questions[$scope.group.hasPositions].options = positions;
                                });
                            }
                        }
                    }, true);
                }

                // Signature Question Type
                if ($scope.question.question_type_id === '3f950186-639d-4932-b623-425e59984d51') {
                    $scope.onCanvasDrawn = function () {
                        $scope.question.signature._isEmpty = false
                    };

                    $scope.clearSignature = function () {
                        $scope.question.signature.clear();
                        $scope.question.signature._isEmpty = true;
                    };

                    $scope.$watch('question.signature', function () {
                        if ($scope.question.signature && $scope.question.signature.onEnd === null) {
                            $scope.question.signature.onEnd = $scope.onCanvasDrawn;
                        }
                    });
                }
                
                $scope.resultClick = function (question) {

                    var questionDefScore = null;
                    if (question.deficiency.score != 'undefined' && typeof question.deficiency.score == 'number') {
                        questionDefScore = question.deficiency.score;
                    }

                    var result = question.answer.newResult;
                    question.answer.show_comments = result.show_comments;
                    if (result.id != question.answer.result_set_id) {
                        if (result.fail == 1) {
                            if (question.answer.fail != null) {
                                if (question.answer.fail == 1) {
                                    $scope.deficiencies.fail--;
                                }
                                else if (question.answer.fail == 0) {
                                    $scope.deficiencies.pass--;
                                    if (questionDefScore != null) {
                                        $scope.deficiencyScore.score -= questionDefScore;
                                    }
                                }
                                else if (question.answer.fail == 2) {
                                    $scope.deficiencies.ignore--;
                                }
                            }

                            $scope.deficiencies.fail++;

                            if (question.sub_components != null && question.sub_components.length > 0) {
                                question.sub_components.forEach(function (subComponent) {
                                    if (subComponent.groups != null && subComponent.groups.length > 0) {
                                        subComponent.groups.forEach(function (subGroup) {
                                            if (subGroup.questions != null && subGroup.questions.length > 0) {
                                                subGroup.questions.forEach(function (subQuestion) {
                                                    if (subQuestion.question_type.code == 'deficiency') {
                                                        if (subQuestion.answer.fail != null) {
                                                            if (subQuestion.answer.fail == 1) {
                                                                $scope.deficiencies.fail--;
                                                            } else if (subQuestion.answer.fail == 0) {
                                                                $scope.deficiencies.pass--;
                                                            } else if (subQuestion.answer.fail == 2) {
                                                                $scope.deficiencies.ignore--;
                                                            }
                                                        }

                                                        subQuestion.answer.fail = null;
                                                        subQuestion.answer.result_set_id = null;
                                                    }
                                                })
                                            }
                                        })
                                    }
                                });
                            }

                            question.answer.fail = 1;
                        }
                        else if (result.fail == 0) {
                            if (question.answer.fail != null) {
                                if (question.answer.fail == 1) {
                                    $scope.deficiencies.fail--;
                                }
                                else if (question.answer.fail == 0) {
                                    $scope.deficiencies.pass--;
                                }
                                else if (question.answer.fail == 2) {
                                    $scope.deficiencies.ignore--;

                                }
                            }

                            if (questionDefScore != null && question.answer.fail != 0) {
                                $scope.deficiencyScore.score += questionDefScore;
                            }
                            $scope.deficiencies.pass++;

                            if (question.sub_components != null && question.sub_components.length > 0) {
                                question.sub_components.forEach(function (subComponent) {
                                    if (subComponent.groups != null && subComponent.groups.length > 0) {
                                        subComponent.groups.forEach(function (subGroup) {
                                            if (subGroup.questions != null && subGroup.questions.length > 0) {
                                                subGroup.questions.forEach(function (subQuestion) {
                                                    if (subQuestion.question_type.code == 'deficiency') {
                                                        if (subQuestion.answer.fail != null) {
                                                            if (subQuestion.answer.fail == 1) {
                                                                $scope.deficiencies.fail--;
                                                            } else if (subQuestion.answer.fail == 0) {
                                                                $scope.deficiencies.pass--;
                                                            } else if (subQuestion.answer.fail == 2) {
                                                                $scope.deficiencies.ignore--;
                                                            }
                                                        }

                                                        $scope.deficiencies.pass++;
                                                        subQuestion.answer.fail = 0;
                                                        subQuestion.answer.result_set_id = result.id;
                                                    }
                                                })
                                            }
                                        })
                                    }
                                });
                            }

                            question.answer.fail = 0;
                        }
                        else if (result.fail == 2) {

                            if (question.answer.fail != null) {
                                if (question.answer.fail == 1) {
                                    $scope.deficiencies.fail--;
                                }
                                else if (question.answer.fail == 0) {
                                    $scope.deficiencies.pass--;
                                    if (questionDefScore != null) {
                                        $scope.deficiencyScore.score -= questionDefScore;
                                    }
                                }
                                else if (question.answer.fail == 2) {
                                    $scope.deficiencies.ignore--;
                                }
                            }

                            $scope.deficiencies.ignore++;

                            if (question.sub_components != null && question.sub_components.length > 0) {
                                question.sub_components.forEach(function (subComponent) {
                                    if (subComponent.groups != null && subComponent.groups.length > 0) {
                                        subComponent.groups.forEach(function (subGroup) {
                                            if (subGroup.questions != null && subGroup.questions.length > 0) {
                                                subGroup.questions.forEach(function (subQuestion) {
                                                    if (subQuestion.question_type.code == 'deficiency') {
                                                        if (subQuestion.answer.fail != null) {
                                                            if (subQuestion.answer.fail == 1) {
                                                                $scope.deficiencies.fail--;
                                                            } else if (subQuestion.answer.fail == 0) {
                                                                $scope.deficiencies.pass--;
                                                            } else if (subQuestion.answer.fail == 2) {
                                                                $scope.deficiencies.ignore--;
                                                            }
                                                        }

                                                        $scope.deficiencies.ignore++;
                                                        subQuestion.answer.fail = 2;
                                                        subQuestion.answer.result_set_id = result.id;
                                                    }
                                                })
                                            }
                                        })
                                    }
                                });
                            }

                            question.answer.fail = 2;
                        }
                    }

                    question.answer.result_set_id = result.id;
                }

                $scope.$watch("group.lastVehicleMileageData", function (mileageData) {
                    if ($scope.question.data_point_code && $scope.question.data_point_code.includes('vehicle_mileage')) {
                        //vehicle mileage - Hours
                        if ($scope.question.data_point_id === '7b751924-eb9f-49a8-b424-c9f957383ede') {
                            $scope.question.tooltip = (mileageData && mileageData.hours) ? "Last Hours: " + mileageData.hours : null;
                            $scope.question.mileageDataLoaded = true;
                        }
                        // vehicle mileage - Mileage
                        else if ($scope.question.data_point_id === '106da601-b6f2-4878-a614-4ca182b80c31') {
                            $scope.question.tooltip = (mileageData && mileageData.mileage) ? "Last Mileage: " + mileageData.mileage : null;
                            $scope.question.mileageDataLoaded = true;
                        }
                        // vehicle mileage - recorded date
                        else if ($scope.question.data_point_id === '9b15840a-18c7-4399-8e3e-a0e5d5bcd14c') {
                            if (mileageData && mileageData.recordedDate) {
                                var recordedDate = new Date(mileageData.recordedDate);
                                var formattedDate = (recordedDate.getMonth() + 1) + '/' + recordedDate.getDate() + '/' + recordedDate.getFullYear();

                                $scope.question.tooltip = mileageData ? "Last Recorded Date: " + formattedDate : null;
                            } else {
                                if ($scope.question.tooltip !== "" || $scope.question.tooltip !== null) { $scope.question.tooltip = null; }
                            }
                            $scope.question.mileageDataLoaded = true;
                        }
                    }
                }, true);
            }]
        };
    }])
    ;